import { IApplicationContext } from 'shared/types/applicationContext';
import { TJsonQuery } from '../../../packages/JsonQuery';

import { fetchGetGeoTags, TGetGeoTagsResponse } from '../../repositories/geo-temp-layer/v1/get-geo-tags';
import { ResponseError } from 'shared/errors';
import { prepareGeoTags } from 'shared/mappers/prepareGeoTags';
import { IDirection, TUndergroundsUnderConstruction } from 'shared/types/geo';
import { IGeoTags } from 'shared/types/tags';
import { TVillage } from 'shared/types/village';

interface IFetchGeoTagsParameters {
  jsonQuery: TJsonQuery;
  subdomain: string;
  directions: IDirection[];
  undergroundsUnderConstruction: TUndergroundsUnderConstruction;
  village: TVillage | null;
}

export async function fetchGeoTags(
  context: IApplicationContext,
  { jsonQuery, subdomain, ...geoTagsMeta }: IFetchGeoTagsParameters,
): Promise<IGeoTags> {
  const { httpApi } = context;

  const { response, statusCode }: TGetGeoTagsResponse = await fetchGetGeoTags({
    httpApi,
    parameters: {
      jsonQuery,
      subdomainName: subdomain,
    },
  });

  if (statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchGeoTags',
      message: response.message || '',
      details: {
        error: JSON.stringify(response.errors),
      },
    });
  }

  return prepareGeoTags(response, geoTagsMeta);
}

export async function fetchGeoTagsSafe(
  context: IApplicationContext,
  parameters: IFetchGeoTagsParameters,
): Promise<IGeoTags> {
  try {
    return await fetchGeoTags(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning('[Degradation] geoTags', ex);

    return {} as IGeoTags;
  }
}
